import User from './user';
import Truck from './truck';
import Drive from './drive';

export default {
    User,
    Truck,
    Drive,
};
